import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import ApiRequest from "../helper/ApiRequest";
import { BaseUrl } from "../helper/BaseUrl";

const blogListEndpoint = ApiEndpoints.blogs.blogList;
export default function BlogDetailCards() {

  const [allData, setAllData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", blogListEndpoint);
      const result = response.blogs;
      setAllData(result);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  // Memoize the formatted blog data
  const displayedBlogs = useMemo(() => {
    if (!allData.length) return [];

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December",
      ];
      return `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    };

    const stripHtmlTags = (htmlString) => htmlString.replace(/<\/?[^>]+(>|$)/g, "");

    return allData.slice(0, 3).map((data) => ({
      ...data,
      formattedDate: formatDate(data.createdAt),
      strippedDescription: stripHtmlTags(data.description),
    }));
  }, [allData]);

  if (!allData.length) {
    return <p style={{ height: "30vh", width:"100%"}}>Loading...</p>;
  }

  return (
    <section className="blogdetail-cards">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="heading center-heading blog-cards-head">
              Related Blogs
            </h4>
          </div>
          {displayedBlogs.map((data, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="blog-card">
                <img
                  className="img-responsive card-img-main"
                  src={`${BaseUrl}${data.image}`}
                  alt="blog-img"
                  loading="lazy"
                />
                <div className="blog-card-content">
                  <div className="blog-date-wrap">
                    <div className="by-togopool-date">
                      <img
                        className="img-responsive"
                        src="../assets/home/by-togopool.webp"
                        alt="logo"
                      />
                      <span>{data.author_name}</span>
                    </div>
                    <div className="by-togopool-date">
                      <img
                        className="img-responsive"
                        src="../assets/home/date-icon.webp"
                        alt="logo"
                        loading="lazy"
                      />
                      <span>{data.formattedDate}</span>
                    </div>
                  </div>
                  <h4 className="heading">{data.name}</h4>
                  <p>{data.strippedDescription}</p>
                  <Link to={`/blog/${data?.slug}`} className="card-link-more">
                    Know More{" "}
                    <img
                      className="img-responsive"
                      src="../assets/home/arrow.webp"
                      alt="arrow"
                      loading="lazy"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
